export default __webpack_public_path__ + "static/summer-send-off-sale-banner-desktop-6a74332d1b8bc1c9bb404c9cefe7b1ec.webp";